module.exports = __webpack_public_path__ + "img/profiling.1f51806e.svg";